import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { setCookieAsync } from "../../features/admin/adminSlice";
import {
  getMemberExperienceDataAsync,
  saveUser,
  saveUsername,
} from "../../features/authentication/authenticationSlice";
import { getSubscriptionDetailsAsync } from "../../features/subscriptions/subscriptionSlice";
import {
  getMonitoringAsync,
  getNeighborhoodWatchMonitoringAreasAsync,
  getPropertyMonitoringAsync,
} from "../../features/monitoring/monitoringSlice";
import {
  getAllListsAsync,
  getAllReportsWithNotesAsync,
  getReportHistoryAsync,
} from "../../features/reports/reportsSlice";
import { selectBrandInfo } from "../../features/brand/brandSlice";
import { fetchCustomerBrokersAsync } from "../../features/profileProtection/profileProtectionSlice";

interface AUTHSyncFromLinkProps {}

const AuthSyncFromLink: React.FC<AUTHSyncFromLinkProps> = () => {
  const { uuid } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const brandInfo = useAppSelector(selectBrandInfo);

  useEffect(() => {
    handleCookieSet();
  }, []);

  const handleCookieSet = async () => {
    if (uuid) {
      const setCookieAsyncResponse = await dispatch(
        setCookieAsync({ uuid: uuid }),
      );
      if (setCookieAsync.fulfilled.match(setCookieAsyncResponse)) {
        console.log("XAuth successful");

        let user = setCookieAsyncResponse.payload;

        dispatch(saveUsername(user.username));
        // need to save user and counter legacy namingScheme
        dispatch(
          saveUser({
            id: user.memberData.id,
            customerId: user.memberData.customerId,
            firstname: user.memberData.firstname,
            lastname: user.memberData.lastname,
            username: user.memberData.username,
            expirationDate: user.memberData.expirationDate,
            createDate: user.memberData.createDate,
            fromLegacy: true, // flag used for monitoring modal. TODO : remove when legacy membersite gone
          }),
        );

        // get subscription details
        await dispatch(getSubscriptionDetailsAsync());

        // get member experience data (we need this await since we want member experience data loaded to determine the view on the dashboard)
        const memberExperienceAction = await dispatch(
          getMemberExperienceDataAsync(),
        );

        const memberExperienceVariant =
          memberExperienceAction.payload?.memberExperienceData?.result?.contents
            .variant;
        if (memberExperienceVariant === "pis75") {
          dispatch(fetchCustomerBrokersAsync());
        }

        // get report history
        dispatch(getReportHistoryAsync());
        // trigger get monitoring
        dispatch(getMonitoringAsync());
        dispatch(getNeighborhoodWatchMonitoringAreasAsync());
        dispatch(getPropertyMonitoringAsync());

        // get lists data
        dispatch(getAllListsAsync());

        // get notes data
        dispatch(getAllReportsWithNotesAsync());

        setTimeout(() => {
          navigate("/");
        }, 0);
      } else {
        console.log("Login fail");
        setTimeout(() => {
          // set error state to be consumed on page
          navigate("/login-link-request", {
            state: { magicLinkExpired: true },
          });
        }, 0);
      }
    }
  };

  return <div>Syncing</div>;
};

export default AuthSyncFromLink;
